// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"wiWjNRm0lPreI9i1-Cqpl","headerTitle":"cNlEXnOB3OT9-h1bQyiEO","qpane":"_2nOQyTJg17u8q6S8_Lm1pz","qpaneSize":"_35olSWQc4GVNvBxmz0szk-","question":"_3SHLaDFOPWn05I1jVB4ekI","insidepane":"Iim6Vsy3X2xNSqRNXyhuw","answerButton":"_1XO0r_mEZAh0RicxLeCor7","stepOn":"ns22pxp4VarDeDBkqe3na","stepOff":"_3du-en0FlRSugR-GvPTyre","coinRight":"_2SO-xpKubOvCOLgFzLG0","coinLeft":"_3KvoEIH0bzWEYSwFW_fIyo","gamble":"_2NP5vMsvwbLrSFiHSxRSbw","gambleBox":"_1ai6e6bMPSZQtxFKMXPM2K","formRadio":"_17QgiaUHYABaqlYNvHMQmN","formRadioFirst":"_1O0Pp_Y0JZAM4JyzavXm4l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/NarrowFraming.css
// module id = 720
// module chunks = 0